import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import Header from '../cabecalho/Cabecalho';
import Menu from '../menu/Menu';
import Rodape from '../rodape/Rodape';
import Titulo from '../titulo/Titulo';
import UsuarioService from '../../service/usuario';

// --- Styled Components (COM CORREÇÕES DE LAYOUT) ---

const CorpoDaPagina = styled.div`
  margin-left: 200px;
  padding-top: 85px;
  padding-bottom: 50px;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;

  @media (max-width: 1200px) {
    margin-left: 60px;
  }

  @media (max-width: 767.98px) {
    margin-left: 0;
  }
`;

// Título centralizado para alinhar com o card
const TituloContainer = styled.div`
  padding: 0 24px;
  margin-top: 20px;
  display: flex;
  justify-content: center;

  @media (max-width: 767.98px) {
    padding: 0 16px;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  overflow-y: auto; // Adiciona o Scroll que você pediu
  padding: 24px;
  display: flex;
  justify-content: center;
`;

const AdminToolsContainer = styled.div`
  width: 90%;
  max-width: 700px;
  height: fit-content;
  padding: 24px 40px;
  position: relative;
  border: 1px solid #c53030;
  box-shadow: #bdbdbd 0px 5px 15px;
  border-radius: 8px;
  background: #fffafa;

  @media (max-width: 768px) {
    padding: 20px;
    width: 95%;
  }
`;

const AdminTitulo = styled.h3`
  font-weight: 800;
  color: #c53030;
  margin-top: 0;
`;

const Label = styled.label`
  color: #58585b;
  font-weight: 500;
  font-size: 14px;
`;

const SearchWrapper = styled.div`
  position: relative;
`;

const SearchContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const SearchInput = styled.input`
  width: 300px;
  height: 32px;
  padding: 6px 10px;
  box-sizing: border-box;
  border: 1px solid #bdbdbd;
  border-radius: 3px;
  font-size: 14px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchResultsDropdown = styled.ul`
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 300px;
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
  z-index: 100;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchResultItem = styled.li`
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const ResetButton = styled.button`
  padding: 7px 20px;
  border-radius: 8px;
  background-color: #A72424; // Vermelho
  color: white;
  border: none;
  cursor: pointer;
  &:hover { background-color: #c53030; }
  
  // Desabilitado
  &:disabled { 
    background-color: #ccc; 
    cursor: not-allowed; 
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px;
  }
`;

const GlobalResetContainer = styled.div`
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #f1c2c2;
`;

const MessageSuccess = styled.div`
  color: #0a7a4a;
  margin-bottom: 15px;
  background: #e6ffef;
  padding: 8px 16px;
  border-radius: 6px;
  border: 1px solid #c7efd6;
`;

const MessageError = styled.div`
  color: #c53030;
  margin-bottom: 15px;
  background: #ffecec;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #f1c2c2;
`;

// --- Início do Componente da Página ---
const GerenciarSenha = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  
  const [adminMessage, setAdminMessage] = useState({ type: '', text: '' });
  const [resetLoading, setResetLoading] = useState(false);
  const [globalResetLoading, setGlobalResetLoading] = useState(false);

  // Hook para "Debounce" (esperar o usuário parar de digitar)
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }
    if (selectedUser && selectedUser.nome !== searchTerm) {
      setSelectedUser(null);
    }

    setIsSearching(true);
    const delayDebounce = setTimeout(async () => {
      try {
        const results = await UsuarioService.searchUsuarios(searchTerm);
        setSearchResults(results);
      } catch (error) {
        setAdminMessage({ type: 'error', text: 'Erro ao buscar usuários.' });
      } finally {
        setIsSearching(false);
      }
    }, 300); 

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, selectedUser]);


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setSearchTerm(user.nome);
    setSearchResults([]);
  };

  const handleResetSpecific = async () => {
    if (!selectedUser) return;

    const confirmado = window.confirm(
      `ATENÇÃO: Você está prestes a resetar a senha de ${selectedUser.nome}.\n\nUma *nova senha aleatória* será gerada e ENVIADA para o e-mail: ${selectedUser.email}.\n\nDeseja continuar?`
    );
    if (!confirmado) return;

    setResetLoading(true);
    setAdminMessage({ type: '', text: '' });
    try {
      const data = await UsuarioService.adminResetPassword(selectedUser._id);
      setAdminMessage({ type: 'success', text: data.mensagem });
      setSelectedUser(null);
      setSearchTerm("");
    } catch (error) {
      setAdminMessage({ type: 'error', text: error.erro || "Erro ao resetar a senha." });
    } finally {
      setResetLoading(false);
    }
  };

  const handleResetGlobal = async () => {
    const confirmado1 = window.confirm(
      "!!!! ATENÇÃO PERIGO !!!!\n\nVocê tem certeza de que quer resetar todas as senhas de todos os usuáris cadastrados (exceto outros admins)?\n\nUma *nova senha aleatória* será gerada e ENVIADA POR E-MAIL para CADA UM deles.\n\nEsta ação é irreversível e pode demorar.\n\nDeseja continuar?"
    );
    if (!confirmado1) return;

    const confirmacaoTexto = window.prompt(
      "Para confirmar, digite 'CONFIRMAR' em maiúsculas:"
    );
    if (confirmacaoTexto !== "CONFIRMAR") {
      alert("Ação cancelada.");
      return;
    }

    setGlobalResetLoading(true);
    setAdminMessage({ type: '', text: '' });
    try {
      const data = await UsuarioService.adminResetAllPasswords();
      setAdminMessage({ type: 'success', text: `${data.mensagem} ${data.usuariosAfetados} senhas resetadas. Falhas: ${data.falhas}.` });
    } catch (error) {
       setAdminMessage({ type: 'error', text: error.erro || "Erro no reset global." });
    } finally {
      setGlobalResetLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Menu />
      <CorpoDaPagina>
        {/* CORREÇÃO DE LAYOUT: O Título agora está dentro de um container com recuo */}
        <TituloContainer>
          <Titulo>Gerenciamento de Senhas</Titulo>
        </TituloContainer>

        <ContentContainer>
          <AdminToolsContainer>
            <AdminTitulo>Ferramentas de Reset de Senha</AdminTitulo>
            
            {adminMessage.text && (
              <div>
                {adminMessage.type === 'success' ? (
                  <MessageSuccess>{adminMessage.text}</MessageSuccess>
                ) : (
                  <MessageError>{adminMessage.text}</MessageError>
                )}
              </div>
            )}

            {/* --- Feature 1: Reset Específico --- */}
            <Label>Resetar senha de um publicador (via e-mail)</Label>
            
            <SearchWrapper>
              <SearchContainer>
                <SearchInput
                  type="text"
                  placeholder="Digite o nome ou e-mail..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                
                {/* O botão agora fica aqui, e só é ativado se um usuário for selecionado */}
                <ResetButton 
                  onClick={handleResetSpecific} 
                  disabled={!selectedUser || resetLoading}
                >
                  {resetLoading ? "Resetando..." : "Resetar Senha"}
                </ResetButton>
                
                {isSearching && <Label>Buscando...</Label>}
              </SearchContainer>
              
              {searchResults.length > 0 && (
                <SearchResultsDropdown>
                  {searchResults.map(user => (
                    <SearchResultItem 
                      key={user._id}
                      onClick={() => handleSelectUser(user)}
                    >
                      {user.nome} ({user.email})
                    </SearchResultItem>
                  ))}
                </SearchResultsDropdown>
              )}
            </SearchWrapper>
            
            {/* O painel azul foi removido */}

            {/* --- Feature 2: Reset Global --- */}
            <GlobalResetContainer>
              <AdminTitulo>Reset Global de Senhas (via e-mail)</AdminTitulo>
              <p style={{ fontSize: '14px', color: '#333', lineHeight: '1.5' }}>
                Este botão irá gerar uma <strong>nova senha aleatória</strong> para <strong>TODOS</strong> os usuários (exceto Admins) e <strong>ENVIARÁ POR E-MAIL</strong>.
              </p>
              <ResetButton onClick={handleResetGlobal} disabled={globalResetLoading}>
                {globalResetLoading ? "Resetando..." : "RESETAR TODAS AS SENHAS"}
              </ResetButton>
            </GlobalResetContainer>

          </AdminToolsContainer>
        </ContentContainer>
      </CorpoDaPagina>
      <Rodape />
    </>
  );
};

export default GerenciarSenha;